export default __webpack_public_path__ + "static/media/39.21dde176.jpeg";